export default __webpack_public_path__ + "static/media/logo-armazem-do-vinho.31ef0a44.png";